module.exports = __webpack_public_path__ + "media/images/shark/BlueOcean_3-p-800-632a8bbad96a83b527698ca440ce8db3.jpeg";